// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__DWR15","checkBox":"style_checkBox__XJvyu","text":"style_text__vyXi0"};